import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { T, rgba } from '../../utils/adminTheme';

interface LoginModalProps {
  onClose: () => void;
  onSuccess?: () => void;
}

const fieldStyle: React.CSSProperties = {
  width: '100%',
  background: T.surface2,
  border: `1px solid ${T.line}`,
  borderRadius: T.r.md,
  padding: '10px 12px',
  fontFamily: T.body,
  fontSize: 14,
  color: T.text,
  outline: 'none',
  boxSizing: 'border-box',
};

const LoginModal: React.FC<LoginModalProps> = ({ onClose, onSuccess }) => {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      setLoading(true);
      setError(null);
      await login(email, password);
      onClose();
      onSuccess?.();
    } catch (err: any) {
      setError(err.message || 'Anmeldung fehlgeschlagen. Bitte prüfen Sie Ihre Zugangsdaten.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 50,
        padding: 16,
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: T.surface,
          border: `1px solid ${T.line}`,
          borderRadius: T.r.lg,
          padding: '28px 24px',
          width: '100%',
          maxWidth: 360,
          position: 'relative',
        }}
      >
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: 12,
            right: 12,
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            color: T.muted,
            fontSize: 16,
            lineHeight: 1,
            padding: 4,
          }}
        >
          ✕
        </button>

        <h2 style={{ margin: '0 0 20px', fontFamily: T.display, fontStyle: 'italic', fontSize: 22, fontWeight: 500, color: T.text }}>
          Admin Login
        </h2>

        {error && (
          <div style={{
            background: rgba('#e53935', 0.07),
            border: `1px solid ${rgba('#e53935', 0.25)}`,
            borderRadius: T.r.md,
            padding: '8px 12px',
            color: '#c62828',
            fontFamily: T.body,
            fontSize: 13,
            marginBottom: 14,
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} style={{ display: 'grid', gap: 12 }}>
          <input
            type="email"
            placeholder="E-Mail"
            value={email}
            onChange={e => setEmail(e.target.value)}
            style={fieldStyle}
            required
          />
          <input
            type="password"
            placeholder="Passwort"
            value={password}
            onChange={e => setPassword(e.target.value)}
            style={fieldStyle}
            required
          />
          <button
            type="submit"
            disabled={loading}
            style={{
              padding: '11px 0',
              background: loading ? T.faint : T.accent,
              border: 'none',
              borderRadius: T.r.md,
              fontFamily: T.body,
              fontSize: 15,
              fontWeight: 600,
              color: loading ? T.muted : '#fff',
              cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'background .15s',
            }}
          >
            {loading ? 'Anmelden…' : 'Anmelden'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginModal;
